var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "13px",
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-700.000000, -201.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(692.000000, 196.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.91181818,1.17473684 L0.521818182,10.1052632 C0.295681036,10.4939366 0.294330867,10.9725138 0.518271422,11.362438 C0.742211977,11.7523622 1.15780765,11.9950672 1.61,12 L12.39,12 C12.8421924,11.9950672 13.257788,11.7523622 13.4817286,11.362438 C13.7056691,10.9725138 13.704319,10.4939366 13.4781818,10.1052632 L8.08818182,1.17473684 C7.85745821,0.797230308 7.44487302,0.566687997 7,0.566687997 C6.55512698,0.566687997 6.14254179,0.797230308 5.91181818,1.17473684 Z",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 4.42105263,
    x2: 7,
    y2: 7.94736863,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 9.47368421,
    x2: 7.00636364,
    y2: 9.47368421,
    stroke: "#000000"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.8ee6e49a.svg";
export { ForwardRef as ReactComponent };